import { render, staticRenderFns } from "./CategoriaFormulario.vue?vue&type=template&id=508f2fc0&scoped=true"
import script from "./CategoriaFormulario.vue?vue&type=script&lang=js"
export * from "./CategoriaFormulario.vue?vue&type=script&lang=js"
import style0 from "./CategoriaFormulario.vue?vue&type=style&index=0&id=508f2fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f2fc0",
  null
  
)

export default component.exports